import { Injectable } from '@angular/core';

@Injectable()
export class CsvService {

  downloadFile(csvHeader:any, data:any, filename='data') {
    let header = csvHeader;

    let csvData = this.ConvertToCSV(header, data);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    dwldLink.innerHTML = "My button";

    // // IE11
    // if(window.navigator.msSaveOrOpenBlob) {
    //     window.navigator.msSaveOrOpenBlob(blob, filename + ".csv");
    //     return;
    // }

    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);

    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(headerList:any, dataList:any) {
    let str = "";
    let header = "";

    // ヘッダー行
    for (let num in headerList) {
      header += this.EscapeData(headerList[num]) + ",";
    }
    header = header.slice(0, -1);
    // データ行
    str += header + "\n";
    for (let i = 0; i < dataList.length; i++) {
      let line = "";
      for (let j = 0; j < dataList[i].length; j++) {
        if (j === 0) {
          line += "\"" + this.EscapeData(dataList[i][j]) + "\"";
        } else {
          line += ",\"" + this.EscapeData(dataList[i][j]) + "\"";
        }
      }
      str += line + "\n";
    }
    return str;
  }

  EscapeData(data:any) {
    var escape_data = data;
    if(typeof(data)=='string') {
      escape_data = data.replace(/"/g,'\"\"');
    }
    return escape_data;
  }

}